import $ from '../vendor/jquery';

$(document).ready(function() {
  if ($("#form-hubCorporateCareerForm").length != 0) {
    $('.property-listing li').each(function() {
      var propertyName = $(this).text();
      var propertySlug = $(this).attr('data-slug');
      $('#form-input-property1').append($('<option>', { value : propertySlug }).text(propertyName));
    });
  }

  $('#form-input-property1').change(function() {
    var property = $("#form-input-property1 option:selected").text();
    var state = $("#form-input-property1 option:selected").val();
    $('#form-input-actualProperty').val(property);
    $('#form-input-actualState').val(state);
  });

});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/job.js